import {MailingList} from "../Interfaces/MailingList";
import {AxiosConfig} from "./AxiosConfig/AxiosConfig";

const checkMailingListFile = async (file: ArrayBuffer | null) => new Promise<Array<string>>((resolve) => {
    if (!file) throw new Error("File is null");
    const formData = new FormData();
    formData.append("file", new Blob([file]));
    AxiosConfig.instance.post(`/mailinglists/check-file`, formData, {headers: {"Content-Type": "multipart/form-data"}}).then(res => {
        return resolve(res.data);
    }).catch(() => {
        resolve([]);
    })
});

const addMailingList = async (list: MailingList) => new Promise<MailingList | null>((resolve) => (
    AxiosConfig.instance.post(`/mailinglists`, list).then(res => {
        const list = res.data.inserted?.[0];
        return resolve(list);
    }).catch(() => {
        resolve(null);
    })
));

const updateMailingList = async (list: MailingList) => new Promise<MailingList | null>((resolve) => (
    AxiosConfig.instance.put(`/mailinglists/${list.id}`, list).then(res => {
        return resolve(res.data);
    }).catch(() => {
        resolve(null);
    })
));

const getAllMailingLists = async () => new Promise<Array<MailingList>>((resolve) => (
    AxiosConfig.instance.get(`/mailinglists`).then(res => {
        return resolve(res.data.data);
    }).catch(() => {
        resolve([]);
    })
));

const deleteMailingList = async (listId: string) => new Promise<boolean>((resolve) => (
    AxiosConfig.instance.delete(`/mailinglists/${listId}`).then(() => {
        return resolve(true);
    }).catch(() => {
        resolve(false);
    })
));

export const MailingListApi = {
    checkMailingListFile,
    addMailingList,
    updateMailingList,
    getAllMailingLists,
    deleteMailingList,
}